export default "__VITE_ASSET__BBc8WRzs__"